"use client";

import { useEffect } from "react";

import { Main } from "@/components/Main";
import { SkipLink } from "@/components/SkipLink";
import { buttonVariants } from "@/components/ui/button";
import { useT } from "@/i18n/react";
import "./css/style.css";

// Replaces the root layout when the layout itself fails, so it brings its own
// html and body, and plain anchors (no router is guaranteed to exist here).
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    // no provider here (the root layout failed): useT() falls back to English
    const t = useT();
    useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <html lang="en">
            <body className="bg-background text-foreground antialiased">
                <SkipLink />
                <Main className="mx-auto flex min-h-screen w-full max-w-xl flex-col justify-center gap-4 px-4 py-10">
                    <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{t("errors.failure.title")}</h1>
                    <p className="text-muted-foreground">{t("errors.failure.globalDetail")}</p>
                    {error.digest ? (
                        <p className="text-sm text-muted-foreground">{t("errors.reference", { digest: error.digest })}</p>
                    ) : null}
                    <div className="flex flex-wrap items-center gap-3">
                        <button type="button" onClick={reset} className={buttonVariants()}>
                            {t("errors.tryAgain")}
                        </button>
                        <a href="/dashboard" className={buttonVariants({ variant: "outline" })}>
                            {t("errors.backToDashboard")}
                        </a>
                    </div>
                </Main>
            </body>
        </html>
    );
}
